<template>
  <div class="row justify-content-center">
    <div class="col-lg-7 col-md-7">
      <div class="card bg-secondary shadow border-0" style="border-radius:10px;">
        <div
          class="card-body px-lg-5 py-lg-5 shadow"
          style="border:2px solid #d0d0d0;border-radius:10px;"
        >
          <div class="text-center text-muted mb-4">
            <i class="fa fa-user fa-fw fa-2x"></i>
            <br />
            <div v-if="sinCajas">
              <i class="fas fa-exclamation-triangle icono-sin-cajas text-warning" />
              <span>El cajero no tiene cajas asociadas</span>
            </div>
            <div v-else>
              <span>Seleccione a que caja desea ingresar</span>
            </div>
          </div>
          <div
            class="row"
            v-for="item in cajas"
            @click="itemClicked(item)"
            v-bind:key="item.CashBoxID"
            style="padding: 5px; border-bottom: 1px solid #d6d4d4; cursor: pointer; margin-right: 0; margin-left: 0"
          >
            <div class="col-md-12">
              <i class="fas fa-cash-register" style="color: #ff5955; margin-right: 10px;"></i>
              {{item.Display}}
            </div>
          </div>
          <div class="row" style="margin-top: 20px;">
            <div class="col-md-12 text-center">
              <b-button
                @click="volver()"
                style="border-color:#f5365c;color:#f5365c;font-weight:100;"
              >Volver</b-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axiosHelpers from "@/helpers/axiosHelpers";
import notificationHelpers from "@/helpers/notificationHelpers";

export default {
  components: {},
  name: "logincajero",
  data() {
    return {
      model: {},
      cajas: [],
      sinCajas: false
    };
  },
  methods: {
    cargarCajas() {
      let context = this;
      axiosHelpers.axiosPost("Login/GetCashBoxByCashier", {}, this, function(
        data
      ) {
        context.cajas = data.ResponseVM.Items;
        context.sinCajas = !data.ResponseVM.Items.length;
      });
    },
    itemClicked(item) {
      let context = this;
      axiosHelpers.axiosPost(
        "Login/LoginCashBox",
        { CashBoxID: item.CashBoxID },
        this,
        function(data) {
          if (data.ResponseVM.Result) {
            context.$router.push("dashboard");
          }
        }
      );
    },
    volver() {
      let context = this;
      context.$store.dispatch("logout").then(() => {
        context.$router.push("login");
      });
    }
  },
  beforeMount: function() {
    this.cargarCajas();
  }
};
</script>

<style lang="scss">
.icono-sin-cajas {
  margin-right: 10px;
}
</style>